// Translations for the CBA (Collective Bargaining Agreements) page.
const cbaDict = [
  { en: "Je, una uhakika unataka kufuta mkataba huu wa CBA?", sw: "Je, una uhakika unataka kufuta mkataba huu wa CBA?" },
  { en: "Mikakati ya Mazungumzo ya Pamoja (CBA)", sw: "Mikakati ya Mazungumzo ya Pamoja (CBA)" },
  { en: "Dhibiti na fuatilia mikataba ya mazungumzo ya pamoja", sw: "Dhibiti na fuatilia mikataba ya mazungumzo ya pamoja" },
  { en: "Ongeza Mkataba Mpya", sw: "Ongeza Mkataba Mpya" },
  { en: "All Statuses", sw: "Hali Zote" },
  { en: "Draft", sw: "Rasimu" },
  { en: "Active", sw: "Inatumika" },
  { en: "Expired", sw: "Imemalizika" },
  { en: "Terminated", sw: "Imekatizwa" },
  { en: "Search by sector...", sw: "Tafuta kwa sekta..." },
  { en: "Expiring Soon", sw: "Inamalizika Hivi Karibuni" },
  { en: "Employer:", sw: "Mwajiri:" },
  { en: "Union:", sw: "Chama:" },
  { en: "Signed:", sw: "Kusainiwa:" },
  { en: "Effective:", sw: "Kuanza:" },
  { en: "Expires:", sw: "Malizika:" },
  { en: "Sector:", sw: "Sekta:" },
  { en: "Edit", sw: "Hariri" },
  { en: "Download Document", sw: "Pakua Hati" },
  { en: "Delete", sw: "Futa" },
  { en: "No CBAs found", sw: "Hakuna mikataba ya CBA iliyopatikana" },
  { en: "If there is a CBA, please add it here.", sw: "Kama kuna mkataba wa CBA, tafadhali ongeza hapa." },
  { en: "Edit CBA", sw: "Hariri Mkataba wa CBA" },
  { en: "Add New CBA", sw: "Ongeza Mkataba Mpya wa CBA" },
  { en: "Agreement Title", sw: "Kichwa cha Mkataba" },
  { en: "Status", sw: "Hali" },
  { en: "Employer Name", sw: "Jina la Mwajiri" },
  { en: "Union Name", sw: "Jina la Chama cha Wafanyakazi" },
  { en: "Signed Date", sw: "Tarehe ya Kusainiwa" },
  { en: "Effective Date", sw: "Tarehe ya Kuanza" },
  { en: "Expiry Date", sw: "Tarehe ya Mwisho" },
  { en: "Sector", sw: "Sekta" },
  { en: "Example: Industry, Agriculture, Education", sw: "Mfano: Viwanda, Kilimo, Elimu" },
  { en: "Description", sw: "Maelezo" },
  { en: "Negotiation History (Optional)", sw: "Historia ya Mazungumzo (Hiari)" },
  { en: "Describe the negotiation history...", sw: "Eleza historia ya mazungumzo..." },
  { en: "Cancel", sw: "Ghairi" },
  { en: "Save Changes", sw: "Hifadhi Mabadiliko" },
];

export default cbaDict;
